/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface InboundDocumentScreenerRequest
 */
export interface InboundDocumentScreenerRequest {
    /**
     * 
     */
    expected_date_modified: Date;
    /**
     * 
     */
    action: InboundDocumentScreenerRequestActionEnum;
    /**
     * 
     */
    facility_id?: string;
    /**
     * 
     */
    lead_id?: string;
    /**
     * 
     */
    include_in_ai_analysis?: boolean;
}


/**
 * @export
 */
export const InboundDocumentScreenerRequestActionEnum = {
    Create: 'CREATE',
    Attach: 'ATTACH',
} as const;
export type InboundDocumentScreenerRequestActionEnum = typeof InboundDocumentScreenerRequestActionEnum[keyof typeof InboundDocumentScreenerRequestActionEnum];


/**
 * Check if a given object implements the InboundDocumentScreenerRequest interface.
 */
export function instanceOfInboundDocumentScreenerRequest(value: object): value is InboundDocumentScreenerRequest {
    if (!('expected_date_modified' in value) || value['expected_date_modified'] === undefined) return false;
    if (!('action' in value) || value['action'] === undefined) return false;
    return true;
}

export function InboundDocumentScreenerRequestFromJSON(json: any): InboundDocumentScreenerRequest {
    return InboundDocumentScreenerRequestFromJSONTyped(json, false);
}

export function InboundDocumentScreenerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboundDocumentScreenerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'expected_date_modified': (json['expected_date_modified'] == null ? json['expected_date_modified'] : parseDateTime(json['expected_date_modified'])),
        'action': json['action'],
        'facility_id': json['facility_id'] == null ? undefined : json['facility_id'],
        'lead_id': json['lead_id'] == null ? undefined : json['lead_id'],
        'include_in_ai_analysis': json['include_in_ai_analysis'] == null ? undefined : json['include_in_ai_analysis'],
    };
}

export function InboundDocumentScreenerRequestToJSON(json: any): InboundDocumentScreenerRequest {
    return InboundDocumentScreenerRequestToJSONTyped(json, false);
}

export function InboundDocumentScreenerRequestToJSONTyped(value?: InboundDocumentScreenerRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expected_date_modified': value['expected_date_modified'] == null ? value['expected_date_modified'] : serializeDateTime(value['expected_date_modified']),
        'action': value['action'],
        'facility_id': value['facility_id'],
        'lead_id': value['lead_id'],
        'include_in_ai_analysis': value['include_in_ai_analysis'],
    };
}

